import { useState } from 'react';
import { useGuideSend } from './GuideSendContext';

/*
 * DER FEHLER STEHT AM KNOPF, NICHT IM KOPF (Rafael, 30.09.2026). Bis hierher landete jedes
 * Scheitern von `enqueue` in der Kopfzeile „Guide: Vorgang fehlgeschlagen" — nach unten
 * gescrollt sah er nichts, und der Klick tat sichtbar nichts. Diese Zeile steht direkt unter
 * dem Absenden-Knopf und bietet den Ausweg gleich mit an:
 *  - Speicher voll -> „Speicher aufräumen" (nur Wegwerf-Caches, nie ein offener Auftrag);
 *
 * KEINE KNOEPFE FUER HAENGENDE EINGABEN MEHR (Rafael, 18.10.2026): eine fruehere Eingabe sperrt
 * die Buehne nicht mehr (GuideSendQueue, `wartetAufVorgaenger`), und ihr Zustellstand ist Sache
 * des Hofs. Hier steht nur noch, was SEINEN Klick wirklich verhindert hat (Speicher voll nach
 * dem automatischen Aufraeumen, unlesbarer lokaler Speicher) — und der Hinweis zu einer
 * umgezogenen Frage.
 */
export default function GuideAbsendeFehler({ buehneId }: { buehneId: string }) {
  const { queue } = useGuideSend();
  const [ergebnis, setErgebnis] = useState<string | null>(null);
  const f = queue?.eingabeFehler?.stageId === buehneId ? queue.eingabeFehler : null;
  if (!queue || (!f && !ergebnis)) return null;
  const knopf = { marginTop: 6, marginRight: 8, fontSize: 11, padding: '4px 10px', borderRadius: 6, cursor: 'pointer',
    background: 'var(--tn-bg)', color: 'var(--tn-text)', border: '1px solid var(--tn-red,var(--tnf-f7768e))' } as const;
  return (
    <div role="alert" data-ai-id={'guide-absende-fehler-' + buehneId}
      style={{ marginTop: 6, padding: '7px 9px', borderRadius: 6, fontSize: 12, lineHeight: 1.4,
        border: '1px solid var(--tn-red,var(--tnf-f7768e))', background: 'rgba(247,118,142,0.08)', color: 'var(--tn-text)' }}>
      {f?.hinweis && <div data-ai-id={'guide-umzug-hinweis-' + buehneId}><b>Frage neu gestellt:</b> {f.meldung}{' '}
        <button type="button" style={knopf} onClick={() => queue.vergissEingabeFehler()}>Verstanden</button></div>}
      {f && !f.hinweis && <div><b>Nicht abgeschickt:</b> {f.speicherVoll ? 'Der Speicher dieser App ist voll.' : f.meldung}</div>}
      {f?.speicherVoll && <div style={{ color: 'var(--tn-text-muted)', fontSize: 11 }}>{f.meldung}</div>}
      {ergebnis && <div style={{ color: 'var(--tn-text-muted)', fontSize: 11 }}>{ergebnis}</div>}
      {f?.speicherVoll && (
        <button type="button" style={knopf} data-ai-id="guide-speicher-aufraeumen" onClick={() => {
          const r = queue.raeumeSpeicherAuf();
          setErgebnis(r.entfernt
            ? `${r.entfernt} Zwischenspeicher entfernt (${Math.round(r.zeichen * 2 / 1024)} KB). Bitte noch einmal absenden.`
            : 'Es gab keine Zwischenspeicher mehr zu entfernen — der Speicher ist mit Eingaben und Layouts belegt. Bitte dem Kanzler melden.');
        }}>Speicher aufräumen</button>
      )}
    </div>
  );
}
